import reducer from './assets.reducer';
import actions from './assets.actions';
import selectors from './assets.selectors';

export default {
  reducer,
  actions,
  selectors,
};
